import { NavBar } from '../../components/layout/NavBar';
import { Footer } from '../../components/layout/Footer';
import { HeroSection } from './components/Hero/HeroSection';
import { AboutSection } from './components/About/AboutSection';
import { ExperienceSection } from './components/Experience/ExperienceSection';
import { ProjectsSection } from './components/Projects/ProjectsSection';
import { SkillsSection } from './components/skills/SkillsSection';
import { EducationSection } from './components/Education/EducationSection';
import { CertificationsSection } from './components/Certifications/CertificationsSection';
import { TalksSection } from './components/Talks/TalksSection';
import { PublicationsSection } from './components/Publications/PublicationsSection';
import { AwardsSection } from './components/Awards/AwardsSection';
import { FurtherTrainingSection } from './components/FurtherTraining/FurtherTrainingSection';
import { VolunteeringSection } from './components/Volunteering/VolunteeringSection';

function Home() {
    return (
        <div className="text-slate-900 dark:text-white">
            <NavBar />
            <HeroSection />
            <AboutSection />
            <ExperienceSection />
            <ProjectsSection />
            <SkillsSection />
            <EducationSection />
            <CertificationsSection />
            <TalksSection />
            <PublicationsSection />
            <AwardsSection />
            <FurtherTrainingSection />
            <VolunteeringSection />
            <Footer />
        </div>
    );
}

export default Home;
